export default __webpack_public_path__ + "88c642b1957898b0a221bc9a97c956a2.png";